<template>
  <div>
    <div v-if="isLoading">
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </div>
    <v-card flat>
      <v-card-text>
        <v-row dense>
          <v-col sm="12" md="6" cols="12">
            <search-bar
              v-model="query.search"
              v-on:clear="clearSearch"
              :label="searchLabel"
              v-on:request-search="onRequestSearch"
            />
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              label="Select publish date"
              solo
              clearable
              hide-details
              readonly
              v-model="formattedDate"
              @click:clear="dateClearCallback"
              prepend-icon="mdi-calendar"
              @click="showDatePickerDialog = true"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6">
            <v-text-field
              clearable
              solo
              append-icon="mdi-magnify"
              label="Search by tag"
              v-model="query.search_tag"
              @click:append="requestTagSearch"
              @keydown.enter="requestTagSearch"
              @click:clear="clearTagSearch"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-pagination
      v-if="this.pagination != undefined && this.pagination.totalItems > 0"
      v-model="pagination.currentPage"
      v-bind:length="pagination.pageCount"
      v-on:input="onRequestPageChange"
      circle
    ></v-pagination>
    <div v-if="!isLoading">
      <v-row class="ma-1">
        <v-col v-if="news !== null && news.length <= 0">
          <v-banner single-line class="text-h6">
            No records
          </v-banner>
        </v-col>
        <v-col
          sm="12"
          md="6"
          v-for="item in news"
          :key="item.id"
          class="d-flex child-flex"
        >
          <just-in-news
            :post="item"
            @priorityChanged="priorityChangeCallback"
            @deleted="deleteSuccessCallback"
            :showPriorityField="showPriorityOrderField"
          />
        </v-col>
      </v-row>
    </div>
    <DatePickerDialog
      @dateSelected="dateSelectionCallback"
      :visible="showDatePickerDialog"
      @close="showDatePickerDialog = false"
    ></DatePickerDialog>
  </div>
</template>

<script>
import jiApi from '@/api/justInNewsApi'
// import snackbar from '@/utils/snackbar'
import DatePickerDialog from '@/components/DatePickerDialog'
import dateUtils from '@/utils/dateUtils'
import * as dateFormats from '@/constants/dateFormats'

export default {
  components: {
    'search-bar': () => import('@/components/SearchBar'),
    DatePickerDialog,
    'just-in-news': () => import('@/components/JustInNewsCard')
  },
  mounted () {
    // When returning from add/edit just in news. check for date
    if (window.publish_date) {
      this.query.publish_date = window.publish_date
      window.publish_date = null
      this.formattedDate = this.$moment(this.query.publish_date).format(
        dateFormats.DDMMYY
      )
    }
    this.fetchJustInNews()
  },

  data: function () {
    return {
      showDatePickerDialog: false,
      formattedDate: null,
      isValid: null,
      imageData: '',
      search: null,
      showPriorityOrderField: false,
      query: {
        search: null,
        search_tag: null,
        sort: null,
        page: 1,
        item_per_page: 16,
        publish_date: null
      },
      searchLabel: 'Search for title or body',
      validation: {
        title: [v => !!v || 'Please enter title']
      },
      pagination: {
        currentPage: 1,
        pageItemFrom: 0,
        pageItemTo: 0,
        totalItems: 0,
        pageCount: 0
      },
      news: [],
      isLoading: false
    }
  },
  methods: {
    requestTagSearch () {
      this.fetchJustInNews()
    },
    clearTagSearch () {
      this.$log.info('clear tag search')
      this.query.search_tag = null
      this.fetchJustInNews()
    },
    priorityChangeCallback () {
      this.fetchJustInNews()
    },
    dateSelectionCallback (data) {
      this.$log.info('date selection callback', [data])
      this.formattedDate = data
      this.query.publish_date = dateUtils.parseDate(data)
      this.togglePriorityField()
      this.fetchJustInNews()
    },
    dateClearCallback () {
      this.$log.info('date clear callback')
      this.query.publish_date = null
      this.togglePriorityField()
      this.fetchJustInNews()
    },
    deleteSuccessCallback () {
      this.fetchJustInNews()
    },
    async fetchJustInNews () {
      try {
        this.isLoading = true
        const response = await jiApi.index(this.query)
        this.parsePaginationData(response.data)
        this.news = response.data.data
      } finally {
        this.isLoading = false
      }
    },
    onRequestSort () {
      this.fetchJustInNews()
    },
    onRequestSearch () {
      this.fetchJustInNews()
    },
    clearSearch () {
      this.query.search = null
      this.fetchJustInNews()
    },
    togglePriorityField () {
      this.$log.info('togglel priority field', [this.query.publish_date])
      if (this.query.publish_date !== null) {
        this.showPriorityOrderField = true
        this.query.sort = 'order:asc'
      } else {
        this.showPriorityOrderField = false
        this.query.sort = 'publish_date:desc'
      }
    },
    parsePaginationData (pagination) {
      this.pagination.currentPage = pagination.current_page
      this.pagination.totalItems = pagination.total
      this.pagination.pageItemFrom = pagination.from
      this.pagination.pageItemTo = pagination.to
      this.pagination.pageCount = pagination.last_page
    },
    onRequestPageChange (pageNo) {
      this.query.page = pageNo
      this.fetchJustInNews()
    }
  }
}
</script>
